(() => {
  const bindMenus = () => document.querySelectorAll('.sf-policy-toggle').forEach(menu => {
    if (menu.dataset.sfBound) return;
    menu.dataset.sfBound = 'true';
    const summary = menu.querySelector('summary');
    const close = () => { menu.open = false; summary.focus(); };
    menu.querySelector('.sf-menu-close').addEventListener('click', close);
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) { event.preventDefault(); close(); }
    });
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) close();
    });
    document.addEventListener('click', event => {
      if (menu.open && !menu.contains(event.target)) menu.open = false;
    });
  });
  bindMenus();
  document.addEventListener('shopify:section:load', bindMenus);
})();
